import BaseStyle from '@primevue/core/base/style';

var StyleClassStyle = BaseStyle.extend({
  name: 'styleclass-directive'
});

export { StyleClassStyle as default };
//# sourceMappingURL=index.mjs.map
